<template>
    <div class="h2">
        <h2><img :src="require(`@/assets/images/${text}.png`)" style="width: 50%;height: auto;"></h2>
    </div>
</template>

<script>
export default {
    props:['text'],
    data() {
        return {
        }
    }
}
</script>

<style scoped>
  
</style>